interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeClasses: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

export default function LoadingSpinner({ size = 'md', label = '加载中...' }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2" role="status">
      <div
        className={`${sizeClasses[size]} animate-spin rounded-full border-[rgba(255,255,255,0.08)] border-t-brand-600`}
        aria-hidden="true"
      />
      <span className="sr-only" aria-live="polite">
        {label}
      </span>
    </div>
  );
}
